document.addEventListener('DOMContentLoaded', async function () {
  const btn = document.getElementById('connectSolanaWallet');

  function isPhantomInstalled() {
    return !!window.solana?.isPhantom;
  }

  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  if (!isPhantomInstalled()) {
    btn.textContent = 'Connect Wallet';
    btn.onclick = function () {
      alert('Please install Phantom Wallet first!');
      window.open('https://phantom.app/', '_blank');
    };
    return;
  }

  // 👇 Check if already connected
  async function checkIfConnected() {
    try {
      const resp = await window.solana.connect({ onlyIfTrusted: true });
      if (resp?.publicKey) {
        btn.textContent = 'Wallet Connected';
        btn.style.background = '#28a745';
      }
    } catch (err) {
      console.log('Wallet not connected yet:', err);
    }
  }

  // Call it on page load
  await checkIfConnected();

  btn.addEventListener('click', async function () {
    if (btn.textContent === 'Wallet Connected') {
      alert('Your wallet is already connected!');
      return;
    }

    try {
      alert('Please look for the Phantom Wallet popup and approve the connection...');

      const connectionTimeout = setTimeout(() => {
        alert('Phantom Wallet not responding. Make sure:\n1. The extension is enabled\n2. You\'re not blocking popups\n3. You try again');
      }, 3000);

      const response = await window.solana.connect();
      clearTimeout(connectionTimeout);

      const publicKey = response.publicKey.toString();
      alert(`Successfully connected to wallet:\n${publicKey}`);

      btn.textContent = 'Wallet Connected';
      btn.style.background = '#28a745';

    } catch (error) {
      alert(`Connection failed: ${error.message}\nPlease try again.`);
      console.error('Wallet connection error:', error);
    }
  });

  if (isMobile()) {
    btn.textContent = 'Open in Phantom Browser';
    btn.style.background = '#17a2b8';
    btn.onclick = function () {
      alert('For best results, open this page in Phantom Browser');
      window.open(`https://phantom.app/ul/browse/${encodeURIComponent(window.location.href)}`, '_blank');
    };
  }
});

// old code which have syncing problem after connecting the wallet when i referesh it again asked me to connect

// document.addEventListener('DOMContentLoaded', async function() {
//   const btn = document.getElementById('connectSolanaWallet');
  
//   // 1. First check if Phantom is installed
//   function isPhantomInstalled() {
//     return !!window.solana?.isPhantom;
//   }

//   // 2. Special handling for mobile devices
//   function isMobile() {
//     return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
//   }

//   if (!isPhantomInstalled()) {
//     btn.textContent = 'Connect Wallet';
//     btn.style.background = '#FFFFFFF';
//     btn.onclick = function() {
//       alert('Please install Phantom Wallet first!');
//       window.open('https://phantom.app/', '_blank');
//     };
//     return;
//   }

//   // 3. Proper connection handler
//   btn.addEventListener('click', async function() {
//     if (btn.textContent === 'Wallet Connected') {
//       alert('Your wallet is already connected!');
//       return;
//     }

//     try {
//       alert('Please look for the Phantom Wallet popup and approve the connection...');
      
//       // 4. Timeout fallback for non-responsive wallets
//       const connectionTimeout = setTimeout(() => {
//         alert('Phantom Wallet not responding. Make sure:\n1. The extension is enabled\n2. You\'re not blocking popups\n3. You try again');
//       }, 3000);

//       // 5. Connect with error handling
//       const response = await window.solana.connect();
//       clearTimeout(connectionTimeout);
      
//       const publicKey = response.publicKey.toString();
//       alert(`Successfully connected to wallet:\n${publicKey}`);
      
//       btn.textContent = 'Wallet Connected';
//       btn.style.background = '#28a745';
      
//     } catch (error) {
//       alert(`Connection failed: ${error.message}\nPlease try again.`);
//       console.error('Wallet connection error:', error);
//     }
//   });

//   // 6. Mobile-specific handling
//   if (isMobile()) {
//     btn.textContent = 'Open in Phantom Browser';
//     btn.style.background = '#17a2b8';
//     btn.onclick = function() {
//       alert('For best results, open this page in Phantom Browser');
//       window.open(`https://phantom.app/ul/browse/${encodeURIComponent(window.location.href)}`, '_blank');
//     };
//   }
// });